import { render, staticRenderFns } from "./warnStatisticsSx.vue?vue&type=template&id=7e33d54c&"
import script from "./warnStatisticsSx.vue?vue&type=script&lang=js&"
export * from "./warnStatisticsSx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports